module.exports = __webpack_public_path__ + "static/media/phoenix.5ef4c59b.jpg";